import { motion } from "framer-motion";
import Reveal from "./Reveal";
import { personal, skills, achievements } from "../data/portfolio";

export default function About() {
  return (
    <section
      id="about"
      style={{
        padding: "7rem 3rem",
        maxWidth: 1200,
        margin: "0 auto",
      }}
    >
      <Reveal>
        <p
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: "0.72rem",
            letterSpacing: "0.22em",
            color: "var(--accent)",
            textTransform: "uppercase",
            marginBottom: "1rem",
          }}
        >
           {/* 01. About */}
        </p>
      </Reveal>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "5rem",
          alignItems: "start",
          marginTop: "3rem",
        }}
        className="about-grid"
      >
        {/* Left: big heading */}
        <Reveal>
          <h2
            style={{
              fontFamily: "var(--font-display)",
              fontSize: "clamp(3.5rem, 7vw, 6.5rem)",
              lineHeight: 0.88,
              color: "var(--text)",
            }}
          >
            BUILT
            <br />
            TO
            <br />
            <span style={{ color: "var(--accent)" }}>SHIP.</span>
          </h2>

          {/* Achievements */}
          <div style={{ marginTop: "3rem", display: "flex", flexDirection: "column", gap: "0.75rem" }}>
            {achievements.map((a, i) => (
              <Reveal key={i} delay={0.1 * i}>
                <motion.div
                  whileHover={{ borderColor: "var(--accent)", x: 4 }}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "1rem",
                    padding: "1rem 1.2rem",
                    border: "1px solid var(--border)",
                    background: "var(--card)",
                    transition: "border-color 0.2s",
                    cursor: "default",
                  }}
                >
                  <div
                    style={{
                      width: 38,
                      height: 38,
                      flexShrink: 0,
                      background: "rgba(57,255,20,0.08)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1.1rem",
                    }}
                  >
                    {a.icon}
                  </div>
                  <div>
                    <div style={{ fontSize: "0.9rem", fontWeight: 500, marginBottom: "0.2rem" }}>
                      {a.title}
                    </div>
                    <div
                      style={{
                        fontFamily: "var(--font-mono)",
                        fontSize: "0.72rem",
                        color: "var(--muted)",
                      }}
                    >
                      {a.sub}
                    </div>
                  </div>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </Reveal>

        {/* Right: bio + skills */}
        <div>
          <Reveal delay={0.1}>
            <p style={{ color: "var(--muted2)", lineHeight: 1.85, fontSize: "1rem", marginBottom: "1.2rem" }}>
              I'm{" "}
              <span style={{ color: "var(--text)", fontWeight: 500 }}>{personal.name}</span>,
              {" "}{personal.bio1.split(personal.name + ",")[1]}
            </p>
            <p style={{ color: "var(--muted2)", lineHeight: 1.85, fontSize: "1rem", marginBottom: "2rem" }}>
              {personal.bio2}
            </p>
          </Reveal>

          {/* Skills */}
          <Reveal delay={0.15}>
            <p
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: "0.7rem",
                color: "var(--muted)",
                letterSpacing: "0.15em",
                textTransform: "uppercase",
                marginBottom: "1rem",
              }}
            >
              Tech Arsenal
            </p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
              {skills.map((skill, i) => (
                <motion.span
                  key={skill}
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.02 * i, duration: 0.3 }}
                  whileHover={{
                    borderColor: "var(--accent)",
                    color: "var(--accent)",
                    y: -2,
                  }}
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: "0.68rem",
                    letterSpacing: "0.06em",
                    color: "var(--text)",
                    border: "1px solid var(--border)",
                    padding: "0.3rem 0.7rem",
                    cursor: "default",
                    transition: "all 0.2s",
                  }}
                >
                  {skill}
                </motion.span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .about-grid { grid-template-columns: 1fr !important; gap: 3rem !important; }
        }
      `}</style>
    </section>
  );
}
